module.exports = __webpack_public_path__ + "img/smile-gallery-07.f8f321cb.jpg";